<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="ScreenFlowSettingsModal Modal--large"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Screen Flow
      </h2>
    </template>
    <template #modal-body>
      <div class="Screen-flow-container">
        <div
          v-if="questions && formHasMoreThanOnePossibleState()"
        >
          <div
            v-for="(question, qIndex) in questions"
            :key="question.question_id"
          >
            <div
              v-if="question.is_state_a_question"
              class="Screen-flow-section"
            >
              <h2>{{ question.label }}</h2>
              <div class="option">
                <rmp-input
                  :model-data="'Default'"
                  :disabled="true"
                />
                <rmp-select
                  v-model="question.defaultTransition.toQuestionLabel"
                  :items="listOfPossibleStatesForDefaultBehaviour.filter((q) => q !== question.label)"
                  @rmp:change="defaultTransitionChanged(qIndex, $event)"
                />
              </div>
              <div
                v-if="question.transitions.length > 0"
                class="Condition-container"
              >
                <div
                  v-for="(transition, tIndex) in question.transitions"
                  :key="tIndex"
                  class="condition"
                >
                  <div
                    v-if="question.type === 'autocomplete' || question.type === 'select' || question.type === 'radio' || question.type === 'checkboxOptGroup' || question.type === 'multi_choice_image'"
                    class="option"
                  >
                    <rmp-input
                      v-model="transition.whenValue"
                      :disabled="true"
                    />
                    <rmp-select
                      v-model="transition.toQuestionLabel"
                      :items="listOfPossibleStatesForConditionalBehaviour.filter((q) => q !== question.label)"
                      @rmp:change="transitionChanged(qIndex, tIndex, $event)"
                    />
                  </div>
                  <div
                    v-else-if="question.type === 'checkbox'"
                    class="option"
                  >
                    <rmp-input
                      v-model="transition.whenValue"
                      :disabled="true"
                    />
                    <rmp-select
                      v-model="transition.toQuestionLabel"
                      :items="listOfPossibleStatesForConditionalBehaviour.filter((q) => q !== question.label)"
                      @rmp:change="transitionChanged(qIndex, tIndex, $event)"
                    />
                  </div>
                  <div
                    v-else
                    class="condition"
                  >
                    <div class="condition-inputs">
                      <rmp-select
                        v-model="transition.whenCondition"
                        class="condition-select"
                        :items="conditionOptions.map((c) => c.label)"
                        @rmp:change="transition.whenValue = null"
                      />
                      <rmp-input
                        v-if="transition.whenCondition === 'equals' || transition.whenCondition === 'not equals' || transition.whenCondition === 'greater than' || transition.whenCondition === 'less than'"
                        v-model="transition.whenValue"
                        placeholder="Enter term"
                        :error="validateStatus($v.questions.$each[qIndex].transitions.$each[tIndex].whenValue, 'Value')"
                        :manual-validate="validateAll"
                      />
                      <rmp-autocomplete-select
                        v-else-if="transition.whenCondition === 'contains' || transition.whenCondition === 'not contains'"
                        v-model="transition.whenValue"
                        placeholder="Enter term and press enter to add a tag"
                        :taggable="true"
                        :multiple="true"
                        :searchable="false"
                        :close-on-select="false"
                        :error="validateStatus($v.questions.$each[qIndex].transitions.$each[tIndex].whenValue, 'Value')"
                        :manual-validate="validateAll"
                      />
                    </div>
                    <rmp-select
                      v-model="transition.toQuestionLabel"
                      :items="listOfPossibleStatesForConditionalBehaviour.filter((q) => q !== question.label)"
                      @rmp:change="transitionChanged(qIndex, tIndex, $event)"
                    />
                  </div>
                </div>
              </div>
              <a
                v-if="showAddConditionButton(question)"
                class="Screen-flow-button"
                @click="addCondition(question.question_id)"
              >Add Condition</a>
              <a
                v-if="question.transitions.length > 0"
                class="Screen-flow-button remove"
                @click="removeConditions(question.question_id)"
              >Remove Conditions</a>
            </div>
          </div>
        </div>
        <div v-else>
          <h4>Not enough questions in the web form to set a screen flow</h4>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :disabled="saveButtonDisabled"
          class="Button Button--green"
          @click="saveFlow"
        >
          Save
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import { requiredIf } from 'vuelidate/lib/validators';
import RmpBaseModal from '@rmpenterprise/base-modal';
import RmpInput from '@rmpenterprise/form-input';
import RmpAutocompleteSelect from '@rmpenterprise/form-autocomplete-select';
import RmpSelect from '@rmpenterprise/form-select';
import ModalActionsMixin from './mixins/modal-actions-mixin';
import ValidationMixin from '../../../mixins/validation-mixin';

export default {
  components: {
    RmpBaseModal,
    RmpInput,
    RmpAutocompleteSelect,
    RmpSelect,
  },
  mixins: [ModalActionsMixin, ValidationMixin],
  data() {
    return {
      questions: null,
      conditionOptions: [
        {
          label: 'equals',
          value: 'equals',
        },
        {
          label: 'not equals',
          value: 'notEquals',
        },
        {
          label: 'contains',
          value: 'contains',
        },
        {
          label: 'not contains',
          value: 'notContains',
        },
        {
          label: 'greater than',
          value: 'greaterThan',
        },
        {
          label: 'less than',
          value: 'lessThan',
        },
        {
          label: 'has answered',
          value: 'hasAnswer',
        },
        {
          label: 'not answered',
          value: 'notAnswer',
        },
      ],
      goToNextQuetion: '-',
      validateAll: false,
      saveButtonDisabled: false,
    };
  },
  computed: {
    listOfPossibleStatesForDefaultBehaviour() {
      return [
        this.goToNextQuetion,
        ...this.questions.map((q) => q.label),
      ];
    },
    listOfPossibleStatesForConditionalBehaviour() {
      return [
        this.goToNextQuetion,
        ...this.questions.map((q) => q.label),
      ];
    },
    transitionsPayload() {
      if (this.questions) {
        const transitionsArray = [];

        this.questions.forEach((question, qIndex) => {
          if (question.type === 'checkbox') {
            // convert "Yes" and "No" values for checkbox questions to 1 or 0 respectively
            question.transitions.forEach((t, tIndex) => {
              this.questions[qIndex].transitions[tIndex].whenValue = t.whenValue === 'Yes' ? 1 : 0;
            });
          }

          // if last question in flow, any transitions with a null 'toQuestionID' ('go to next question' is selected) should have the condition set to 'default' so backend discards them
          if (qIndex === this.questions.length - 1) {
            question.transitions.forEach((t) => {
              if (!t.toQuestionID) {
                t.whenCondition = 'default'; // eslint-disable-line
              }
            });
          }

          if (question.is_state_a_question && question.defaultTransition.toQuestionLabel !== '-') {
            transitionsArray.push(
              question.defaultTransition,
              ...question.transitions,
            );
          }

          if (question.is_state_a_question && question.defaultTransition.toQuestionLabel === '-') {
            transitionsArray.push(
              ...question.transitions,
            );
          }
        });
        return {
          transitions: [
            ...transitionsArray.filter((t) => t.toQuestionLabel !== this.goToNextQuetion).map((x) => {
              const condition = x.whenCondition === 'default' ? 'default' : this.conditionOptions.find((c) => x.whenCondition === c.label).value;

              return {
                from_web_form_question_id: x.fromQuestionID,
                when_condition: condition,
                when_value: x.whenValue,
                go_to_web_form_question_id: x.toQuestionID,
              };
            }),
          ],
        };
      }

      return null;
    },
  },
  mounted() {
    this.getScreenFlow(this.$route.params.id)
      .then((response) => {
        this.parseScreenFlowResponse(response);
        this.$emit('screen-flow-settings:responseSuccess');
      });
  },
  methods: {
    ...mapActions('events', ['getScreenFlow', 'saveScreenFlowSettings']),
    parseScreenFlowResponse(response) {
      const transitions = response.data.transitions.map((t) => {
        const toQuestion = response.data.states.find((s) => s.question_id === t.go_to_web_form_question_id);
        const toQuestionLabel = toQuestion !== undefined ? toQuestion.label : this.goToNextQuetion;
        return {
          fromQuestionID: t.from_web_form_question_id,
          whenCondition: t.when_condition === 'default' ? 'default' : this.conditionOptions.find((c) => c.value === t.when_condition).label,
          whenValue: t.when_value,
          toQuestionID: t.go_to_web_form_question_id,
          toQuestionLabel,
        };
      });

      // consolidate questions and transitions to make it easier to deal with in template
      this.questions = response.data.states.map((question, index) => {
        let defaultTransition = transitions.find((t) => t.fromQuestionID === question.question_id && t.whenCondition === 'default');
        if (!defaultTransition) {
          // backend ignores last question in flow if condition is 'default' and next question is 'null', so add it back here to allow the user to change if required
          defaultTransition = {
            fromQuestionID: question.question_id,
            whenCondition: 'default',
            whenValue: null,
            toQuestionID: response.data.states[index + 1] ? response.data.states[index + 1].question_id : null,
            toQuestionLabel: this.goToNextQuetion,
          };
        }
        return {
          ...question,
          defaultTransition,
          transitions: transitions
            .filter((t) => t.fromQuestionID === question.question_id && t.whenCondition !== 'default')
            .map((t) => {
              return {
                fromQuestionID: t.fromQuestionID,
                whenCondition: t.whenCondition,
                whenValue: t.whenValue,
                toQuestionID: t.toQuestionID,
                toQuestionLabel: t.toQuestionLabel,
              };
            }),
        };
      });
    },
    addCondition(questionID) {
      const index = this.questions.findIndex((q) => q.question_id === questionID);

      switch (this.questions[index].type) {
        case 'autocomplete':
        case 'select':
        case 'radio':
        case 'checkboxOptGroup':
        case 'multi_choice_image':
          // add transitions for each option
          this.questions[index].options.forEach((o) => {
            this.questions[index].transitions.push(
              {
                fromQuestionID: questionID,
                whenCondition: 'equals',
                whenValue: o.value,
                toQuestionID: this.questions[index + 1] ? this.questions[index + 1].question_id : null,
                toQuestionLabel: this.goToNextQuetion,
              },
            );
          });

          break;
        case 'checkbox':
          // add two transitions, one for yes and one for no
          this.questions[index].transitions.push(
            {
              fromQuestionID: questionID,
              whenCondition: 'equals',
              whenValue: 'Yes',
              toQuestionID: this.questions[index + 1] ? this.questions[index + 1].question_id : null,
              toQuestionLabel: this.goToNextQuetion,
            },
            {
              fromQuestionID: questionID,
              whenCondition: 'equals',
              whenValue: 'No',
              toQuestionID: this.questions[index + 1] ? this.questions[index + 1].question_id : null,
              toQuestionLabel: this.goToNextQuetion,
            },
          );

          break;
        default:
          // add single transition
          this.questions[index].transitions.push(
            {
              fromQuestionID: questionID,
              whenCondition: 'equals',
              whenValue: null,
              toQuestionID: this.questions[index + 1] ? this.questions[index + 1].question_id : null,
              toQuestionLabel: this.goToNextQuetion,
            },
          );
      }
    },
    showAddConditionButton(question) {
      if ((question.type === 'autocomplete' || question.type === 'select' || question.type === 'radio' || question.type === 'checkboxOptGroup' || question.type === 'checkbox') && question.transitions.length > 0) {
        return false;
      }

      return true;
    },
    removeConditions(questionID) {
      const index = this.questions.findIndex((q) => q.question_id === questionID);
      this.questions[index].transitions = [];
    },
    getQuestionID(question) {
      return this.questions.find((q) => q.label === question).question_id;
    },
    transitionChanged(questionIndex, transitionIndex, selectedQuestion) {
      if (selectedQuestion !== this.goToNextQuetion) {
        this.questions[questionIndex].transitions[transitionIndex].toQuestionID = this.getQuestionID(selectedQuestion);
      }
    },
    defaultTransitionChanged(questionIndex, newQuestion) {
      if (questionIndex === this.goToNextQuetion) {
        this.questions[questionIndex].transitions = [];
      }

      if (newQuestion !== this.goToNextQuetion) {
        this.questions[questionIndex].defaultTransition.toQuestionID = this.getQuestionID(newQuestion);
      }
    },

    /*
      A state is a path where a question might go to, so in order to create flows we need more than 1 question.
      So why > 2 and not > 1? Good question!
      There this a special state which is not question, it's a state that allows the user to stop and submit the form.
      Thus, we do > 2 and not > 1.
     */
    formHasMoreThanOnePossibleState() {
      return this.questions.length > 2;
    },
    saveFlow() {
      this.validateAll = true;
      if (this.$v.$invalid) {
        return;
      }

      this.validateAll = false;
      this.saveButtonDisabled = true;

      const payload = this.transitionsPayload;
      this.saveScreenFlowSettings({
        eventID: this.$route.params.id,
        payload,
      })
        .then((response) => {
          this.isOpen = false;
          this.$bus.$emit('displayMsg', {
            text: 'Screen flow successfully updated',
            type: 'success',
          });
          this.parseScreenFlowResponse(response);
        })
        .catch((error) => {
          this.$bus.$emit('displayMsg', {
            text: error.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.saveButtonDisabled = false;
        });
    },
  },
  validations() {
    return {
      questions: {
        $each: {
          transitions: {
            $each: {
              whenValue: {
                required: requiredIf((transition) => transition.whenCondition !== 'has answered' && transition.whenCondition !== 'not answered'),
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.Screen-flow-container {
  padding-top: 20px;

  .Screen-flow-section {
    width: 100%;
    min-height: 50px;
    padding: 25px;
    margin-bottom: 20px;
    border: 1px solid #b6b6b6;
    border-radius: 3px;
    display: inline-block;

    .Condition-container {
      border-top: 1px solid #b6b6b6;

      .condition {
        padding-top: 10px;

        .condition-inputs {
          display: flex;

          .condition-select {
            width: 20%;
          }

          .Form-field {
            margin-bottom: 15px;
          }
        }
      }
    }

    .option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      column-gap: 10px;

      .Form-field {
        margin-bottom: 0;
      }
    }

    .Screen-flow-button {
      text-decoration: underline;
      cursor: pointer;
    }

    .remove {
      color: red;
      float: right;
    }
  }
}
</style>
